import React from 'react';
import logo from '../../../../images/logo/IE-logo-2.png'


const Page1 = ({
  firstPageRef,
  sending,
  styledInput,
  styledDisabledInput = { border: '1px solid rgba(0,0,0,0.18)', backgroundColor: '#e5e7eb', color: '#4b5563' },
  lockedQuoteFields = { isFromQuote: false, healthPlan: false, age: false },
  isValid,
  styledNotValid,
  plansData,
  handlePlansDataChange,
  primaryApplicantData,
  handlePrimaryApplicantChange,
  spouseData,
  handleSpouseChange,
  dependents,
  handleDependentsChange,
  plansValidity,
  primaryApplicantValidity,
  primaryFormatValidity = { phoneNumber: true, zip: true, email: true, employerZip: true },
  optionalFieldsValidity = {
    primaryDoctorPhone: true,
    primaryDoctorZip: true,
    spouseSsn: true,
    spousePhone: true,
    spouseZip: true,
    spouseEmail: true,
    spouseEmployerZip: true,
    spouseDoctorPhone: true,
    spouseDoctorZip: true,
  },
  primaryApplicantDataNotRequired,
  handlePrimaryApplicantDataNotRequired,
  ssnMinMaxValidity,
  displayedDateFormats
}) => {
  const reqBadge = "bg-red-600 text-white text-[8px] font-bold px-1 py-[0.5px] rounded shadow z-20 whitespace-nowrap pointer-events-none";

  const toDateInputString = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const getBirthDateRange = (ageValue) => {
    const today = new Date();
    const parsedAge = parseInt(String(ageValue || '').trim(), 10);
    if (!isNaN(parsedAge) && parsedAge >= 18 && parsedAge <= 64) {
      const minDate = new Date(today.getFullYear() - parsedAge - 1, today.getMonth(), today.getDate() + 1);
      const maxDate = new Date(today.getFullYear() - parsedAge, today.getMonth(), today.getDate());
      return {
        min: toDateInputString(minDate),
        max: toDateInputString(maxDate),
      };
    }
    const minDate = new Date(today.getFullYear() - 65, today.getMonth(), today.getDate() + 1);
    const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    return {
      min: toDateInputString(minDate),
      max: toDateInputString(maxDate),
    };
  };

  const primaryBirthDateRange = getBirthDateRange(primaryApplicantData.age);

  return (
    <>

      <div ref={firstPageRef} className='w-[816px] min-h-[1104px] border border-gray-300 bg-white text-[9.2px] font-pdf p-[24px] shadow-xl relative'>
        <div className='border-[4px] min-h-[calc(100%-50px)] w-full border-[#305496] relative pb-8'>


          {/* 1st row */}
          <div className='grid grid-cols-3'>
            <div className='font-bold'>FOR OFFICE USE ONLY</div>
            <div className='border-r border-l border-[#305496] font-[700] tracking-tighter py-7 text-center text-[17px]'>INSURANCE ENROLLMENT</div>
            <div className='font-bold flex flex-col justify-center items-center text-blue-600'>
              <div><img src={logo} alt='IE logo' style={{ height: '40px' }} /></div>
              <div className='text-sm font-bold'>(888) 350-6605</div>
              <div>www.insuranceenterpriseusa.com</div>
            </div>
          </div>




          {/* 2nd row */}
          <div className='grid grid-cols-1'>
            <div className='border-y-[3px] font-bold border-[#305496] bg-indigo-300 text-center'>PLEASE PRINT ELIGIBLY</div>
          </div>




          {/* 3rd row */}
          <div className='grid grid-cols-[25px_1fr]'>
            <div className='w-[25px]'></div>

            <div className='grid grid-cols-20 border-b border-[#305496]'>

              <div className='border-r border-[#305496] pl-8 col-span-5'>
                <div className='relative'>Desired Effective Date: <span className={`absolute -top-1 text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                <div className=''>
                  {
                    sending ?
                      displayedDateFormats.desiredEffectiveDate :
                      <div className='relative group'>
                        {!plansValidity.desiredEffectiveDate && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='date'
                          data-invalid={!plansValidity.desiredEffectiveDate}
                          name='desiredEffectiveDate'
                          style={plansValidity.desiredEffectiveDate ? styledInput : styledNotValid}
                          value={plansData.desiredEffectiveDate}
                          onChange={handlePlansDataChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>

              <div className='border-r border-[#305496] text-center col-span-4 relative'>
                <div className='relative'>Quoted Monthly Premium:</div>
                <div className='flex items-start justify-start h-full pl-2'>
                  <span>$</span>
                  <div className=''>
                    {
                      sending ?
                        plansData.quotedMonthlyPremium :
                        <div className='relative group'>
                          <input
                            type='number'
                            name='quotedMonthlyPremium'
                            style={styledDisabledInput}
                            value={plansData.quotedMonthlyPremium}
                            readOnly
                            disabled
                            tabIndex={-1}
                            className='bg-gray-200 text-gray-600 w-[90%] cursor-not-allowed px-1 rounded-[2px]'
                          />
                        </div>
                    }
                  </div>
                </div>
              </div>

              <div className='border-r border-[#305496] text-center col-span-5 relative'>
                <div className='relative'>Deductible:</div>
                <div className='flex items-start justify-start h-full pl-2'>
                  <span className='mr-1'>$</span>
                  <div className=''>
                    {
                      sending ?
                        plansData.deductible :
                        <div className='relative group'>
                          <input
                            type='number'
                            name='deductible'
                            style={styledDisabledInput}
                            value={plansData.deductible}
                            readOnly
                            disabled
                            tabIndex={-1}
                            className='bg-gray-200 text-gray-600 w-[90%] cursor-not-allowed px-1 rounded-[2px]'
                          />
                        </div>
                    }
                  </div>
                </div>
              </div>


              <div className='grid grid-cols-3 col-span-6 '>
                <div className='border-r border-b border-[#305496] underline text-center relative'>Health Plan Selection: <span className={`absolute -bottom-[2px] text-sm text-error  ${sending || lockedQuoteFields.healthPlan ? 'hidden' : ''}`}>*</span></div>
                <div data-invalid={!plansValidity.healthPlan && !lockedQuoteFields.healthPlan} className={`border-b border-[#305496] text-center flex justify-evenly col-span-2 pt-2 relative ${lockedQuoteFields.healthPlan && !sending ? 'bg-gray-200 text-gray-600 cursor-not-allowed' : ''}`} style={plansValidity.healthPlan || sending || lockedQuoteFields.healthPlan ? {} : styledNotValid}>
                  {!plansValidity.healthPlan && !sending && !lockedQuoteFields.healthPlan && (
                    <div className={`absolute -top-3 right-1 ${reqBadge}`}>Required</div>
                  )}
                  <div className='relative group'>
                    <div>
                      <input type='radio' className={`w-2 h-2 ${lockedQuoteFields.healthPlan && !sending ? 'cursor-not-allowed opacity-70' : ''}`} name='healthPlan' value='silver' checked={plansData.healthPlan === 'silver'} disabled={lockedQuoteFields.healthPlan && !sending} onChange={handlePlansDataChange} /> Silver Tier
                    </div>
                  </div>
                  <div>
                    <input type='radio' className={`w-2 h-2 ${lockedQuoteFields.healthPlan && !sending ? 'cursor-not-allowed opacity-70' : ''}`} name='healthPlan' value='gold' checked={plansData.healthPlan === 'gold'} disabled={lockedQuoteFields.healthPlan && !sending} onChange={handlePlansDataChange} /> Gold Tier
                  </div>
                </div>

                <div className='border-r border-[#305496] underline text-center relative'>Dental Plan Selection: <span className={`absolute -bottom-[2px]  text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>


                <div data-invalid={!plansValidity.dentalPlan} className='col-span-2 flex justify-evenly relative group' style={plansValidity.dentalPlan || sending ? {} : styledNotValid}>
                  {!plansValidity.dentalPlan && !sending && (
                    <div className={`absolute -top-3 right-1 ${reqBadge}`}>Required</div>
                  )}
                  <div className='text-center'>
                    <div><input type='radio' className='w-2 h-2 mr-[2px]' name='dentalPlan' value='none' checked={plansData.dentalPlan === 'none'} onChange={handlePlansDataChange} />None
                    </div>
                    <div><input type='radio' className='w-2 h-2 mr-[2px]' name='dentalPlan' value='single' checked={plansData.dentalPlan === 'single'} onChange={handlePlansDataChange} />Single
                    </div>
                  </div>
                  <div className='text-center'>
                    <div><input type='radio' className='w-2 h-2 mr-[2px]' name='dentalPlan' value='couple' checked={plansData.dentalPlan === 'couple'} onChange={handlePlansDataChange} />Couple
                    </div>
                    <div><input type='radio' className='w-2 h-2 mr-[2px]' name='dentalPlan' value='family' checked={plansData.dentalPlan === 'family'} onChange={handlePlansDataChange} />Family
                    </div>
                  </div>
                  {lockedQuoteFields.isFromQuote && !sending && (
                    <div className='absolute left-[calc(100%+40px)] top-1/2 -translate-y-1/2 w-[235px] bg-[#f0fdf4] border-2 border-[#2AA107] text-slate-800 rounded-xl shadow-lg p-3 z-30 text-left font-sans text-[11px] leading-snug pointer-events-none'>
                      <div className='absolute -left-[9px] top-1/2 -translate-y-1/2 w-4 h-4 bg-[#f0fdf4] border-l-2 border-b-2 border-[#2AA107] rotate-45'></div>
                      <p className='font-semibold text-[#166534] mb-2'>
                        Dental, vision, and hearing plans are separate from your primary health coverage.
                      </p>
                      <p className='text-slate-700'>
                        Selecting an option generates an independent quote, an agent will reach out directly with your quote details.
                      </p>
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>




          {/* 4th row */}
          {/* PRIMARY APPLICANT */}
          <div className='grid grid-cols-[25px_1fr] mt-[-1px]'>

            <div className='border-l border-t-[4px] border-r-[4px] row-span-13 flex items-center justify-center bg-indigo-300 border-[#305496] ml-[-1px]'>
              <div className='-rotate-90 h-[25px] text-nowrap flex items-center ml-[-3px] font-bold text-[14px]'>PRIMARY APPLICANT</div>
            </div>




            {/* 5th - Birthdate row */}
            <div className='grid grid-cols-20 border-b border-[#305496]'>
              <div className='border-r border-b border-[#305496] col-span-9 relative'>

                <div className='grid grid-cols-3'>
                  <div className='ml-1 relative'>Last Name <span className={`absolute -top-[3px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                  <div className='ml-1 relative'>First Name <span className={`absolute -top-[3px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                  <div className='ml-1'>Middle Name</div>
                </div>
                <div className='grid grid-cols-3 relative'>
                  {
                    sending ?
                      <>
                        <div className='ml-1 break-words leading-tight'>{`${primaryApplicantData.lastName + ","}`}</div>
                        <div className='ml-1 break-words leading-tight'>{`${primaryApplicantData.firstName}`}</div>
                        <div className='ml-1 break-words leading-tight'>{`${primaryApplicantDataNotRequired.middleName}`}</div>
                      </>
                      :
                      <>
                        <div className='relative group'>
                          {!primaryApplicantValidity.lastName && (
                            <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                          )}
                          <input
                            type='text'
                            data-invalid={!primaryApplicantValidity.lastName}
                            name='lastName'
                            style={primaryApplicantValidity.lastName ? styledInput : styledNotValid}
                            value={primaryApplicantData.lastName}
                            onChange={handlePrimaryApplicantChange}
                            className='ml-1 w-[90%]'
                          />
                        </div>
                        <div className='relative group'>
                          {!primaryApplicantValidity.firstName && (
                            <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                          )}
                          <input
                            type='text'
                            data-invalid={!primaryApplicantValidity.firstName}
                            name='firstName'
                            style={primaryApplicantValidity.firstName ? styledInput : styledNotValid}
                            value={primaryApplicantData.firstName}
                            onChange={handlePrimaryApplicantChange}
                            className='ml-1 w-[90%]'
                          />
                        </div>
                        <input
                          type='text'
                          name='middleName'
                          style={styledInput}
                          value={primaryApplicantDataNotRequired.middleName}
                          onChange={handlePrimaryApplicantDataNotRequired}
                          className='ml-1 w-[90%]'
                        />
                      </>
                  }
                </div>
              </div>

              <div data-invalid={!primaryApplicantValidity.gender} className='border-r border-b border-[#305496] pl-1 pt-1 z-10 col-span-2 relative group' style={primaryApplicantValidity.gender || sending ? {} : styledNotValid}>
                 <span className={`absolute top-0 right-1 text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>
                 {!primaryApplicantValidity.gender && !sending && (
                   <div className={`absolute -top-3 left-0 ${reqBadge}`}>Required</div>
                 )}
                <div><input type='radio' className='w-2 h-2 mr-[2px]' name='gender' value='Male' checked={primaryApplicantData.gender === 'Male'} onChange={handlePrimaryApplicantChange} /> Male</div>
                <div><input type='radio' className='w-2 h-2 mr-[2px]' name='gender' value='Female' checked={primaryApplicantData.gender === 'Female'} onChange={handlePrimaryApplicantChange} /> Female</div>
              </div>

              <div className='border-r border-b border-[#305496] py-[2px] col-span-3 relative'>
                <div className='relative'>Social Security Number: <span className={`absolute -top-[3px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                <div className='flex justify-center'>
                  {
                    sending ?
                      primaryApplicantData.ssn :
                      <div className='relative group'>
                        <div className={`absolute ${!ssnMinMaxValidity || !primaryApplicantValidity.ssn ? 'block' : 'hidden'} bg-red-600 -top-3.5 left-0 text-white text-[8px] font-bold py-[0.5px] px-1 text-center rounded whitespace-nowrap z-20 pointer-events-none`}>
                          {!ssnMinMaxValidity ? 'Invalid SSN (9 digits)' : 'Required'}
                        </div>
                        <input
                          type='text'
                          inputMode='numeric'
                          data-invalid={!primaryApplicantValidity.ssn || !ssnMinMaxValidity}
                          name='ssn'
                          style={primaryApplicantValidity.ssn && ssnMinMaxValidity ? styledInput : styledNotValid}
                          value={primaryApplicantData.ssn}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>


              <div className='grow grid row-span-2 col-span-6'>
                <div className='pl-1'>How did you find us:</div>
                <div className='flex justify-evenly py-[2px]'>
                  <div className=''><input type='radio' name='howDidYouFindUs' value='Social Media' checked={primaryApplicantDataNotRequired.howDidYouFindUs === 'Social Media'} className='w-2 h-2 mr-[2px] cursor-pointer' onClick={handlePrimaryApplicantDataNotRequired} onChange={() => {}} />Social Media</div>
                  <div className=''><input type='radio' name='howDidYouFindUs' value='Google' checked={primaryApplicantDataNotRequired.howDidYouFindUs === 'Google'} className='w-2 h-2 mr-[2px] cursor-pointer' onClick={handlePrimaryApplicantDataNotRequired} onChange={() => {}} />Google</div>
                </div>
                <div className='flex justify-evenly py-[2px]'>
                  <div className=''><input type='radio' name='howDidYouFindUs' value='Fax' checked={primaryApplicantDataNotRequired.howDidYouFindUs === 'Fax'} className='w-2 h-2 mr-[2px] cursor-pointer' onClick={handlePrimaryApplicantDataNotRequired} onChange={() => {}} />Fax</div>
                  <div className=''><input type='radio' name='howDidYouFindUs' value='Referral' checked={primaryApplicantDataNotRequired.howDidYouFindUs === 'Referral'} className='w-2 h-2 mr-[2px] cursor-pointer' onClick={handlePrimaryApplicantDataNotRequired} onChange={() => {}} />Referral</div>
                </div>


                <div className='border-t border-[#305496] relative'>
                  <div className='flex items-center'>
                    <span className='whitespace-nowrap pl-1'>Referred By:{primaryApplicantDataNotRequired.howDidYouFindUs === 'Referral' && <span className={`text-sm text-error ${sending ? 'hidden' : ''}`}> *</span>}</span>
                    <div className='flex justify-center w-full'>
                      {
                        sending ?
                          primaryApplicantDataNotRequired.referredBy :
                          <div className='relative group w-full flex justify-center'>
                            {!primaryApplicantValidity.referredBy && (
                              <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                            )}
                            <input
                              type='text'
                              name='referredBy'
                              data-invalid={!primaryApplicantValidity.referredBy}
                              style={primaryApplicantValidity.referredBy ? styledInput : styledNotValid}
                              value={primaryApplicantDataNotRequired.referredBy}
                              onChange={handlePrimaryApplicantDataNotRequired}
                              className='bg-transparent w-[90%]'
                            />
                          </div>
                      }
                    </div>
                  </div>
                </div>
              </div>




              {/* Birthdate row */}

              <div className='border-r border-[#305496] col-span-5 flex items-center'>Birth Date: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>* &nbsp;</span>
                <div className='flex justify-center'>
                  {
                    sending ?
                      displayedDateFormats.primaryApplicantBirthDate :
                      <div className='relative group'>
                        {!primaryApplicantValidity.birthDate && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>
                            {primaryApplicantData.birthDate && primaryApplicantData.age ? `Must match Age (${primaryApplicantData.age})` : 'Required'}
                          </div>
                        )}
                        <input
                          type='date'
                          data-invalid={!primaryApplicantValidity.birthDate}
                          name='birthDate'
                          min={primaryBirthDateRange.min}
                          max={primaryBirthDateRange.max}
                          style={primaryApplicantValidity.birthDate ? styledInput : styledNotValid}
                          value={primaryApplicantData.birthDate}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[100%]'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] col-span-2 flex justify-center items-center'>Age: <span className={`text-sm text-error  ${sending || lockedQuoteFields.age ? 'hidden' : ''}`}>*&nbsp;</span>
                <div className='flex justify-center'>
                  {
                    sending ?
                      primaryApplicantData.age :
                      <div className='relative group'>
                        {!primaryApplicantValidity.age && !lockedQuoteFields.age && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='number'
                          inputMode='numeric'
                          data-invalid={!primaryApplicantValidity.age && !lockedQuoteFields.age}
                          min={18}
                          max={64}
                          name='age'
                          readOnly={lockedQuoteFields.age}
                          disabled={lockedQuoteFields.age}
                          tabIndex={lockedQuoteFields.age ? -1 : undefined}
                          style={lockedQuoteFields.age ? styledDisabledInput : (primaryApplicantValidity.age ? styledInput : styledNotValid)}
                          value={primaryApplicantData.age}
                          onChange={handlePrimaryApplicantChange}
                          className={`w-[90%] ${lockedQuoteFields.age ? 'bg-gray-200 text-gray-600 cursor-not-allowed px-1 rounded-[2px]' : 'bg-transparent'}`}
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] col-span-7 flex items-center'>Birth State/County: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*&nbsp;</span>
                <div className='flex justify-center'>
                  {
                    sending ?
                      primaryApplicantData.birthStateCounty :
                      <div className='relative group'>
                        {!primaryApplicantValidity.birthStateCounty && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          data-invalid={!primaryApplicantValidity.birthStateCounty}
                          name='birthStateCounty'
                          style={primaryApplicantValidity.birthStateCounty ? styledInput : styledNotValid}
                          value={primaryApplicantData.birthStateCounty}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>
            </div>




            {/* 6th row */}
            <div className='grid grid-cols-8 border-b border-[#305496] min-h-[23px]'>
              <div className='border-r border-[#305496] py-[2px] col-span-3 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Home Address: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{primaryApplicantData.homeAddress}</span> :
                      <div className='relative group w-full'>
                        {!primaryApplicantValidity.homeAddress && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          data-invalid={!primaryApplicantValidity.homeAddress}
                          name='homeAddress'
                          style={primaryApplicantValidity.homeAddress ? styledInput : styledNotValid}
                          value={primaryApplicantData.homeAddress}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Apt #.:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{primaryApplicantDataNotRequired.aptNumber}</span> :
                      <input
                        type='text'
                        name='aptNumber'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.aptNumber}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='bg-transparent w-[90%]'
                      />
                  }
                </div>
              </div>

              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>City: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{primaryApplicantData.city}</span> :
                      <div className='relative group w-full'>
                        {!primaryApplicantValidity.city && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          data-invalid={!primaryApplicantValidity.city}
                          name='city'
                          style={primaryApplicantValidity.city ? styledInput : styledNotValid}
                          value={primaryApplicantData.city}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>

              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>County: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{primaryApplicantData.county}</span> :
                      <div className='relative group w-full'>
                        {!primaryApplicantValidity.county && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          data-invalid={!primaryApplicantValidity.county}
                          name='county'
                          style={primaryApplicantValidity.county ? styledInput : styledNotValid}
                          value={primaryApplicantData.county}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>State: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{primaryApplicantData.state}</span> :
                      <div className='relative group w-full'>
                        {!primaryApplicantValidity.state && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          data-invalid={!primaryApplicantValidity.state}
                          name='state'
                          style={primaryApplicantValidity.state ? styledInput : styledNotValid}
                          value={primaryApplicantData.state}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Zip: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{primaryApplicantData.zip}</span> :
                      <div className='relative group w-full'>
                        <div className={`absolute ${!primaryFormatValidity.zip || !primaryApplicantValidity.zip ? 'block' : 'hidden'} bg-red-600 -top-3.5 right-0 text-white text-[8px] font-bold py-[0.5px] px-1 text-center rounded whitespace-nowrap z-20 pointer-events-none`}>
                          {!primaryFormatValidity.zip ? 'Invalid 5-Digit ZIP' : 'Required'}
                        </div>
                        <input
                          type='text'
                          inputMode='numeric'
                          maxLength={5}
                          placeholder="5-digit ZIP"
                          data-invalid={!primaryApplicantValidity.zip || !primaryFormatValidity.zip}
                          name='zip'
                          style={primaryApplicantValidity.zip && primaryFormatValidity.zip ? styledInput : styledNotValid}
                          value={primaryApplicantData.zip}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>
            </div>




            {/* 7th row */}
            <div className='grid grid-cols-7 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-2'>
                <div className='relative'>Phone Number: <span className={`absolute -top-[3px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                <div className='flex justify-center w-full px-1'>
                  {
                    sending ?
                      primaryApplicantData.phoneNumber :
                      <div className='relative group'>
                        <div className={`absolute ${!primaryFormatValidity.phoneNumber || !primaryApplicantValidity.phoneNumber ? 'block' : 'hidden'} bg-red-600 -top-3.5 left-0 text-white text-[8px] font-bold py-[0.5px] px-1 text-center rounded whitespace-nowrap z-20 pointer-events-none`}>
                          {!primaryFormatValidity.phoneNumber ? 'Invalid Phone Number' : 'Required'}
                        </div>
                        <input
                          type='tel'
                          placeholder="(XXX) XXX-XXXX"
                          data-invalid={!primaryApplicantValidity.phoneNumber || !primaryFormatValidity.phoneNumber}
                          name='phoneNumber'
                          style={primaryApplicantValidity.phoneNumber && primaryFormatValidity.phoneNumber ? styledInput : styledNotValid}
                          value={primaryApplicantData.phoneNumber}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>


              <div data-invalid={!primaryApplicantValidity.bestTimeToCall} className='border-r border-[#305496] py-[2px] relative group' style={primaryApplicantValidity.bestTimeToCall || sending ? {} : styledNotValid}>
                Best Time To Call:  <span className={`absolute -top-[3px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>
                {!primaryApplicantValidity.bestTimeToCall && !sending && (
                  <div className={`absolute -top-3 right-1 ${reqBadge}`}>Required</div>
                )}
                <div className='flex justify-evenly py-[2px]'>
                  <div className=''><input type='radio' name='bestTimeToCall' value='AM' checked={primaryApplicantData.bestTimeToCall === 'AM'} onChange={handlePrimaryApplicantChange} className='w-2 h-2 mr-[2px]' />AM</div>
                  <div className=''><input type='radio' name='bestTimeToCall' value='PM' checked={primaryApplicantData.bestTimeToCall === 'PM'} onChange={handlePrimaryApplicantChange} className='w-2 h-2 mr-[2px]' />PM</div>
                </div>
              </div>


              <div className='border-r border-[#305496] py-[2px]'>
                <div className='relative'>Height (ft/in):  <span className={`absolute -top-[3px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                <div className='flex justify-center w-full px-1'>
                  {
                    sending ?
                      `${primaryApplicantData.heightFeet + "'"}${primaryApplicantData.heightInch + '"'}` :
                      <div className='relative group w-full'>
                        {(!primaryApplicantValidity.heightFeet || !primaryApplicantValidity.heightInch) && (
                          <div className={`absolute -top-3.5 right-0 ${reqBadge}`}>Required</div>
                        )}
                        <div className='flex justify-between w-full'>
                          <div className='flex items-center'>
                            <select
                              data-invalid={!primaryApplicantValidity.heightFeet}
                              style={primaryApplicantValidity.heightFeet ? styledInput : styledNotValid}
                              name='heightFeet'
                              value={primaryApplicantData.heightFeet}
                              onChange={handlePrimaryApplicantChange}
                            >
                              <option value="" defaultValue></option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                            </select>
                            <div className='ml-[2px]'>ft</div>
                          </div>
                          <div className='flex items-center'>
                            <select
                              data-invalid={!primaryApplicantValidity.heightInch}
                              style={primaryApplicantValidity.heightInch ? styledInput : styledNotValid}
                              name='heightInch'
                              value={primaryApplicantData.heightInch}
                              onChange={handlePrimaryApplicantChange}
                            >
                              <option value="" defaultValue></option>
                              <option value="0">0</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                            <div className='ml-[2px]'>in</div>
                          </div>
                        </div>
                      </div>
                  }
                </div>
              </div>


              <div className='border-r border-[#305496] py-[2px]'>
                <div className='relative'>Weight (lbs)  <span className={`absolute -top-[3px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>:</div>
                <div className='flex justify-center w-full px-1'>
                  {
                    sending ?
                      `${primaryApplicantData.weight} lbs` :
                      <div className='relative group'>
                        {!primaryApplicantValidity.weight && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='number'
                          data-invalid={!primaryApplicantValidity.weight}
                          name='weight'
                          style={primaryApplicantValidity.weight ? styledInput : styledNotValid}
                          value={primaryApplicantData.weight}
                          onChange={handlePrimaryApplicantChange}
                          className='w-full'
                        />
                      </div>
                  }
                </div>
              </div>


              <div className='border-r border-[#305496] py-[2px]'>
                <div>Drivers License/ID #:</div>
                <div className='flex justify-center w-full px-1'>
                  {
                    sending ?
                      primaryApplicantDataNotRequired.driversLicense :
                      <input
                        type='number'
                        name='driversLicense'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.driversLicense}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>


              <div className='border-[#305496] py-[2px]'>
                <div>DL Issuing State:</div>
                <div className='flex justify-center w-full px-1'>
                  {
                    sending ?
                      primaryApplicantDataNotRequired.dlIssuingState :
                      <input
                        type='text'
                        name='dlIssuingState'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.dlIssuingState}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 8th row */}
            <div className='grid grid-cols-7 border-b border-[#305496]'>

              <div data-invalid={!primaryApplicantValidity.maritalStatus} className='border-r border-[#305496] py-[2px] flex items-center justify-between col-span-3 relative group' style={primaryApplicantValidity.maritalStatus || sending ? {} : styledNotValid}>
                {!primaryApplicantValidity.maritalStatus && !sending && (
                  <div className={`absolute -top-3 left-16 ${reqBadge}`}>Required</div>
                )}
                <div className='relative'>Marital Status  <span className={`absolute -top-[3px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                <div className='flex justify-evenly py-[2px] space-x-2 pr-2'>
                  <div className=''><input type='radio' className='w-2 h-2 mr-[2px]' name='maritalStatus' value='Single' checked={primaryApplicantData.maritalStatus === 'Single'} onChange={handlePrimaryApplicantChange} />Single</div>
                  <div className=''><input type='radio' className='w-2 h-2 mr-[2px]' name='maritalStatus' value='Married' checked={primaryApplicantData.maritalStatus === 'Married'} onChange={handlePrimaryApplicantChange} />Married</div>
                  <div className=''><input type='radio' className='w-2 h-2 mr-[2px]' name='maritalStatus' value='Divorced' checked={primaryApplicantData.maritalStatus === 'Divorced'} onChange={handlePrimaryApplicantChange} />Divorced</div>
                  <div className=''><input type='radio' className='w-2 h-2 mr-[2px]' name='maritalStatus' value='Widowed' checked={primaryApplicantData.maritalStatus === 'Widowed'} onChange={handlePrimaryApplicantChange} />Widowed</div>
                </div>
              </div>
              <div className='py-[2px] col-span-4 flex items-center min-w-0 relative'>
                <span className='whitespace-nowrap relative'>Email Adress:  <span className={`absolute -top-[3px] left-14 text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>&nbsp;</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-all leading-tight'>{primaryApplicantData.email}</span> :
                      <div className='relative group'>
                        <div className={`absolute ${!primaryFormatValidity.email || !primaryApplicantValidity.email ? 'block' : 'hidden'} bg-red-600 -top-3.5 left-0 text-white text-[8px] font-bold py-[0.5px] px-1 text-center rounded whitespace-nowrap z-20 pointer-events-none`}>
                          {!primaryFormatValidity.email ? 'Invalid Email Address' : 'Required'}
                        </div>
                        <input
                          type='email'
                          data-invalid={!primaryApplicantValidity.email || !primaryFormatValidity.email}
                          name='email'
                          style={primaryApplicantValidity.email && primaryFormatValidity.email ? styledInput : styledNotValid}
                          value={primaryApplicantData.email}
                          onChange={handlePrimaryApplicantChange}
                          className='bg-transparent w-[90%]'
                        />
                      </div>
                  }
                </div>
              </div>
            </div>




            {/* 9th row */}

            <div className='grid grid-cols-7 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-3 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Primary Beneficiary Name:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.primaryBeneficiaryName}</span> :
                      <input
                        type='text'
                        name='primaryBeneficiaryName'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.primaryBeneficiaryName}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='bg-transparent w-[90%]'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] col-span-4 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Relationship:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.primaryBeneficiaryRelationship}</span> :
                      <input
                        type='text'
                        name='primaryBeneficiaryRelationship'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.primaryBeneficiaryRelationship}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='bg-transparent w-[90%]'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 10th row */}

            <div className='grid grid-cols-7 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-3 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Secondary Beneficiary Name:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.secondaryBeneficiaryName}</span> :
                      <input
                        type='text'
                        name='secondaryBeneficiaryName'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.secondaryBeneficiaryName}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='bg-transparent w-[90%]'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] col-span-4 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Relationship:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.secondaryBeneficiaryRelationship}</span> :
                      <input
                        type='text'
                        name='secondaryBeneficiaryRelationship'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.secondaryBeneficiaryRelationship}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='bg-transparent w-[90%]'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 11th row */}

            <div className='grid border-b border-[#305496]'>
              <div className='border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Current Insurance Provider (if any):</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.currentInsuranceProvider}</span> :
                      <input
                        type='text'
                        name='currentInsuranceProvider'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.currentInsuranceProvider}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='bg-transparent w-[90%]'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 12th row */}

            <div className='grid grid-cols-8 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-2 min-w-0'>
                <span className='whitespace-nowrap px-1 block mb-[2px]'>Primary Doctor's Name:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.doctorName}</span> :
                      <input
                        type='text'
                        name='doctorName'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.doctorName}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] col-span-2 min-w-0'>
                <span className='whitespace-nowrap px-1 block mb-[2px]'>Phone:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.doctorPhone}</span> :
                      <div className='relative group w-full'>
                        <input
                          type='tel'
                          placeholder='(XXX) XXX-XXXX'
                          name='doctorPhone'
                          data-invalid={!optionalFieldsValidity.primaryDoctorPhone}
                          style={optionalFieldsValidity.primaryDoctorPhone ? styledInput : styledNotValid}
                          value={primaryApplicantDataNotRequired.doctorPhone}
                          onChange={handlePrimaryApplicantDataNotRequired}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.primaryDoctorPhone && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] left-0 whitespace-nowrap pointer-events-none">
                            Invalid Phone Number
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] col-span-2 min-w-0'>
                <span className='whitespace-nowrap px-1 block mb-[2px]'>Date of Last Doctor Visit:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{displayedDateFormats.primaryApplicantLastDoctorVisitDate}</span> :
                      <input
                        type='date'
                        name='doctorDateOfLastVisit'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.doctorDateOfLastVisit}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] col-span-2 min-w-0'>
                <span className='whitespace-nowrap px-1 block mb-[2px]'>Reason for Doctor Visit:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.doctorResonForVisit}</span> :
                      <input
                        type='text'
                        name='doctorResonForVisit'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.doctorResonForVisit}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 13th row */}

            <div className='grid grid-cols-7'>
              <div className='border-r border-[#305496] py-[2px] col-span-3 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Doctor's Address:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.doctorAddress}</span> :
                      <input
                        type='text'
                        name='doctorAddress'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.doctorAddress}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Suite #:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.doctorSuiteNumber}</span> :
                      <input
                        type='text'
                        name='doctorSuiteNumber'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.doctorSuiteNumber}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>City:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.doctorCity}</span> :
                      <input
                        type='text'
                        name='doctorCity'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.doctorCity}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>State:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.doctorState}</span> :
                      <input
                        type='text'
                        name='doctorState'
                        style={styledInput}
                        value={primaryApplicantDataNotRequired.doctorState}
                        onChange={handlePrimaryApplicantDataNotRequired}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Zip:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantDataNotRequired.doctorZip}</span> :
                      <div className='relative group w-full'>
                        <input
                          type='text'
                          inputMode='numeric'
                          maxLength={5}
                          placeholder='5-digit ZIP'
                          name='doctorZip'
                          data-invalid={!optionalFieldsValidity.primaryDoctorZip}
                          style={optionalFieldsValidity.primaryDoctorZip ? styledInput : styledNotValid}
                          value={primaryApplicantDataNotRequired.doctorZip}
                          onChange={handlePrimaryApplicantDataNotRequired}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.primaryDoctorZip && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] right-0 whitespace-nowrap pointer-events-none">
                            Invalid 5-Digit ZIP
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
            </div>




            {/* 14th row */}
            <div className='grid'>
              <div className='border-y border-[#305496] py-[2px] bg-indigo-100 font-bold'>EMPLOYER</div>
            </div>




            {/* 15th row */}

            <div className='grid grid-cols-5 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0 relative'>
                <span className='whitespace-nowrap relative'>Employer Name:  <span className={`absolute -top-[3px] -right-3 text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>&nbsp;</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantData.employerName}</span> :
                      <div className='relative group'>
                        {!primaryApplicantValidity.employerName && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          name='employerName'
                          data-invalid={!primaryApplicantValidity.employerName}
                          style={primaryApplicantValidity.employerName ? styledInput : styledNotValid}
                          value={primaryApplicantData.employerName}
                          onChange={handlePrimaryApplicantChange}
                          className='w-full'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Occupation / Job Title:  <span className='relative'><span className={`absolute -top-[4px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>&nbsp;</span></span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantData.employerJob}</span> :
                      <div className='relative group'>
                        {!primaryApplicantValidity.employerJob && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          name='employerJob'
                          data-invalid={!primaryApplicantValidity.employerJob}
                          style={primaryApplicantValidity.employerJob ? styledInput : styledNotValid}
                          value={primaryApplicantData.employerJob}
                          onChange={handlePrimaryApplicantChange}
                          className='w-full'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] flex items-center min-w-0 relative'>
                <span className='whitespace-nowrap'>Annual Income: $  <span className='relative'><span className={`absolute -top-[4px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>&nbsp;</span></span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantData.employerAnnualIncome}</span> :
                      <div className='relative group'>
                        {!primaryApplicantValidity.employerAnnualIncome && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='number'
                          name='employerAnnualIncome'
                          data-invalid={!primaryApplicantValidity.employerAnnualIncome}
                          style={primaryApplicantValidity.employerAnnualIncome ? styledInput : styledNotValid}
                          value={primaryApplicantData.employerAnnualIncome}
                          onChange={handlePrimaryApplicantChange}
                          className='w-full'
                        />
                      </div>
                  }
                </div>
              </div>
            </div>




            {/* 16th row */}

            <div className='grid grid-cols-5 border-b-[3px] border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Address:  <span className='relative'><span className={`absolute -top-[4px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>&nbsp;</span></span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantData.employerAddress}</span> :
                      <div className='relative group'>
                        {!primaryApplicantValidity.employerAddress && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          name='employerAddress'
                          data-invalid={!primaryApplicantValidity.employerAddress}
                          style={primaryApplicantValidity.employerAddress ? styledInput : styledNotValid}
                          value={primaryApplicantData.employerAddress}
                          onChange={handlePrimaryApplicantChange}
                          className='w-full'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>City:  <span className='relative'><span className={`absolute -top-[4px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>&nbsp;</span></span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantData.employerCity}</span> :
                      <div className='relative group'>
                        {!primaryApplicantValidity.employerCity && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          name='employerCity'
                          data-invalid={!primaryApplicantValidity.employerCity}
                          style={primaryApplicantValidity.employerCity ? styledInput : styledNotValid}
                          value={primaryApplicantData.employerCity}
                          onChange={handlePrimaryApplicantChange}
                          className='w-full'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>State:  <span className='relative'><span className={`absolute -top-[4px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>&nbsp;</span></span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantData.employerState}</span> :
                      <div className='relative group'>
                        {!primaryApplicantValidity.employerState && (
                          <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                        )}
                        <input
                          type='text'
                          name='employerState'
                          data-invalid={!primaryApplicantValidity.employerState}
                          style={primaryApplicantValidity.employerState ? styledInput : styledNotValid}
                          value={primaryApplicantData.employerState}
                          onChange={handlePrimaryApplicantChange}
                          className='w-full'
                        />
                      </div>
                  }
                </div>
              </div>
              <div className='py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Zip:  <span className='relative'><span className={`absolute -top-[4px] text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>&nbsp;</span></span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{primaryApplicantData.employerZip}</span> :
                      <div className='relative group'>
                        <input
                          type='text'
                          inputMode='numeric'
                          maxLength={5}
                          placeholder="5-digit ZIP"
                          name='employerZip'
                          data-invalid={!primaryApplicantValidity.employerZip || !primaryFormatValidity.employerZip}
                          style={primaryApplicantValidity.employerZip && primaryFormatValidity.employerZip ? styledInput : styledNotValid}
                          value={primaryApplicantData.employerZip}
                          onChange={handlePrimaryApplicantChange}
                          className='w-full'
                        />
                        {(!primaryFormatValidity.employerZip || !primaryApplicantValidity.employerZip) && (
                          <div className={`absolute -top-3.5 right-0 ${reqBadge}`}>
                            {!primaryFormatValidity.employerZip ? 'Invalid 5-Digit ZIP' : 'Required'}
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>




          {/* SPOUSE */}
          <div className='grid grid-cols-[25px_1fr] mt-[-3px]'>

            <div className='border-l border-t-[4px] border-b-[4px] border-r-[4px] row-span-13 flex items-center justify-center bg-indigo-300 border-[#305496] ml-[-1px]'>
              <div className='-rotate-90 h-[25px] text-nowrap flex items-center ml-[-3px] font-bold text-[14px]'>SPOUSE(if any)</div>
            </div>




            {/* 17th row */}

            <div className='grid grid-cols-21 border-b border-t-[4px] border-[#305496]'>
              <div className='border-r border-[#305496] col-span-9 relative'>
                <div className='grid grid-cols-3'>
                  <div>Last Name</div>
                  <div className='ml-1'>First Name</div>
                  <div className='ml-1'>Middle Name</div>
                </div>
                <div className='grid grid-cols-3 relative'>
                  {
                    sending ?
                      <>
                        <div className='ml-1 break-words leading-tight'>{`${spouseData.lastName === "" ? "" : spouseData.lastName + ","}`}</div>
                        <div className='ml-1 break-words leading-tight'>{`${spouseData.firstName}`}</div>
                        <div className='ml-1 break-words leading-tight'>{`${spouseData.middleName}`}</div>
                      </>
                      :
                      <>
                        <input
                          type='text'
                          name='lastName'
                          style={styledInput}
                          value={spouseData.lastName}
                          onChange={handleSpouseChange}
                          className=''
                        />
                        <input
                          type='text'
                          name='firstName'
                          style={styledInput}
                          value={spouseData.firstName}
                          onChange={handleSpouseChange}
                          className='ml-1'
                        />
                        <input
                          type='text'
                          name='middleName'
                          style={styledInput}
                          value={spouseData.middleName}
                          onChange={handleSpouseChange}
                          className='ml-1'
                        />
                      </>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] col-span-2 pl-1 pt-1'>
                <div className=''><input type='radio' className='w-2 h-2 mr-[2px]' name='spouse-gender' /> Male</div>
                <div className=''><input type='radio' className='w-2 h-2 mr-[2px]' name='spouse-gender' /> Female</div>
              </div>
              <div className='border-r border-[#305496] pt-1 col-span-5'>
                <div>Social Security Number:</div>
                <div className='flex justify-center'>
                  {
                    sending ?
                      spouseData.ssn :
                      <div className='relative group w-[80%]'>
                        <input
                          type='text'
                          inputMode='numeric'
                          name='ssn'
                          data-invalid={!optionalFieldsValidity.spouseSsn}
                          style={optionalFieldsValidity.spouseSsn ? styledInput : styledNotValid}
                          value={spouseData.ssn}
                          onChange={handleSpouseChange}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.spouseSsn && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] left-0 whitespace-nowrap pointer-events-none">
                            Invalid SSN (9 digits)
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] col-span-5'>
                <div>Drivers License/ID #:</div>
                <div className='flex justify-center w-full px-1'>
                  {
                    sending ?
                      spouseData.driversLicense :
                      <input
                        type='number'
                        name='driversLicense'
                        style={styledInput}
                        value={spouseData.driversLicense}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 18th row */}

            <div className='grid grid-cols-7 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-3 min-w-0'>
                <span className='whitespace-nowrap'>Home Address (if different from above):</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{spouseData.homeAddress}</span> :
                      <input
                        type='text'
                        name='homeAddress'
                        style={styledInput}
                        value={spouseData.homeAddress}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Apt #.:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{spouseData.aptNumber}</span> :
                      <input
                        type='text'
                        name='aptNumber'
                        style={styledInput}
                        value={spouseData.aptNumber}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>City:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{spouseData.city}</span> :
                      <input
                        type='text'
                        name='city'
                        style={styledInput}
                        value={spouseData.city}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>State:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{spouseData.state}</span> :
                      <input
                        type='text'
                        name='state'
                        style={styledInput}
                        value={spouseData.state}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Zip:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{spouseData.zip}</span> :
                      <div className='relative group w-full'>
                        <input
                          type='text'
                          inputMode='numeric'
                          maxLength={5}
                          placeholder="5-digit ZIP"
                          name='zip'
                          data-invalid={!optionalFieldsValidity.spouseZip}
                          style={optionalFieldsValidity.spouseZip ? styledInput : styledNotValid}
                          value={spouseData.zip}
                          onChange={handleSpouseChange}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.spouseZip && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] right-0 whitespace-nowrap pointer-events-none">
                            Invalid 5-Digit ZIP
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
            </div>




            {/* 19th row */}

            <div className='grid grid-cols-10 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Birth Date:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      displayedDateFormats.spouseBirthDate :
                      <input
                        type='date'
                        name='birthDate'
                        min={new Date(new Date().setFullYear(new Date().getFullYear() - 64)).toISOString().split('T')[0]}
                        max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0]}
                        style={styledInput}
                        value={spouseData.birthDate}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Age:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      spouseData.age :
                      <input
                        type='number'
                        name='age'
                        style={styledInput}
                        value={spouseData.age}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>

              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Height (ft/in):</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      `${spouseData.heightFeet === "" ? "" : spouseData.heightFeet + "'"}${spouseData.heightInch === "" ? '' : spouseData.heightInch + '"'}` :
                      <div className='relative group w-full'>
                        <div className='flex justify-between w-full'>
                          <div className='flex items-center'>
                            <select
                              style={styledInput}
                              name='heightFeet'
                              value={spouseData.heightFeet}
                              onChange={handleSpouseChange}
                            >
                              <option value="" defaultValue></option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                            </select>
                            <div className='ml-[2px]'>ft</div>
                          </div>
                          <div className='flex items-center'>
                            <select
                              style={styledInput}
                              name='heightInch'
                              value={spouseData.heightInch}
                              onChange={handleSpouseChange}
                            >
                              <option value="" defaultValue></option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                            <div className='ml-[2px]'>in</div>
                          </div>
                        </div>
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Weight (lbs):</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      spouseData.weight :
                      <input
                        type='number'
                        name='weight'
                        style={styledInput}
                        value={spouseData.weight}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] col-span-3 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Birth State/County:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{spouseData.birthStateCounty}</span> :
                      <input
                        type='text'
                        name='birthStateCounty'
                        style={styledInput}
                        value={spouseData.birthStateCounty}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 20th row */}

            <div className='grid grid-cols-7 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0 col-span-2'>
                <span className='whitespace-nowrap'>Phone Number:</span>
                <div className='flex justify-center w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight text-center'>{spouseData.phoneNumber}</span> :
                      <div className='relative group w-full'>
                        <input
                          type='tel'
                          placeholder="(XXX) XXX-XXXX"
                          name='phoneNumber'
                          data-invalid={!optionalFieldsValidity.spousePhone}
                          style={optionalFieldsValidity.spousePhone ? styledInput : styledNotValid}
                          value={spouseData.phoneNumber}
                          onChange={handleSpouseChange}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.spousePhone && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] left-0 whitespace-nowrap pointer-events-none">
                            Invalid Phone Number
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px]'>
                Best Time To Call:
                <div className='flex justify-evenly py-[2px]'>
                  <div className=''><input type='radio' className='w-2 h-2 mr-[2px]' name='spouse-best-time-to-call' />AM</div>
                  <div className=''><input type='radio' className='w-2 h-2 mr-[2px]' name='spouse-best-time-to-call' />PM</div>
                </div>
              </div>
              <div className='py-[2px] flex items-center min-w-0 col-span-4'>
                <span className='whitespace-nowrap'>Email Adress:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-all leading-tight'>{spouseData.email}</span> :
                      <div className='relative group w-full'>
                        <input
                          type='email'
                          name='email'
                          data-invalid={!optionalFieldsValidity.spouseEmail}
                          style={optionalFieldsValidity.spouseEmail ? styledInput : styledNotValid}
                          value={spouseData.email}
                          onChange={handleSpouseChange}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.spouseEmail && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] left-0 whitespace-nowrap pointer-events-none">
                            Invalid Email Address
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
            </div>




            {/* 21st row */}

            <div className='grid grid-cols-7 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-3 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Primary Beneficiary Name:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.primaryBeneficiaryName}</span> :
                      <input
                        type='text'
                        name='primaryBeneficiaryName'
                        style={styledInput}
                        value={spouseData.primaryBeneficiaryName}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] col-span-4 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Relationship:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.primaryBeneficiaryRelationship}</span> :
                      <input
                        type='text'
                        name='primaryBeneficiaryRelationship'
                        style={styledInput}
                        value={spouseData.primaryBeneficiaryRelationship}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 22nd row */}

            <div className='grid grid-cols-7 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-3 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Secondary Beneficiary Name:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.secondaryBeneficiaryName}</span> :
                      <input
                        type='text'
                        name='secondaryBeneficiaryName'
                        style={styledInput}
                        value={spouseData.secondaryBeneficiaryName}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] col-span-4 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Relationship:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.secondaryBeneficiaryRelationship}</span> :
                      <input
                        type='text'
                        name='secondaryBeneficiaryRelationship'
                        style={styledInput}
                        value={spouseData.secondaryBeneficiaryRelationship}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 23rd row */}

            <div className='grid border-b border-[#305496]'>
              <div className='border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Current Insurance Provider (if any):</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.currentInsuranceProvider}</span> :
                      <input
                        type='text'
                        name='currentInsuranceProvider'
                        style={styledInput}
                        value={spouseData.currentInsuranceProvider}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 24th row */}

            <div className='grid grid-cols-8 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-2 min-w-0'>
                <span className='whitespace-nowrap px-1 block mb-[2px]'>Primary Doctor's Name:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.doctorName}</span> :
                      <input
                        type='text'
                        name='doctorName'
                        style={styledInput}
                        value={spouseData.doctorName}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] col-span-2 min-w-0'>
                <span className='whitespace-nowrap px-1 block mb-[2px]'>Phone:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.doctorPhone}</span> :
                      <div className='relative group w-full'>
                        <input
                          type='tel'
                          placeholder='(XXX) XXX-XXXX'
                          name='doctorPhone'
                          data-invalid={!optionalFieldsValidity.spouseDoctorPhone}
                          style={optionalFieldsValidity.spouseDoctorPhone ? styledInput : styledNotValid}
                          value={spouseData.doctorPhone}
                          onChange={handleSpouseChange}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.spouseDoctorPhone && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] left-0 whitespace-nowrap pointer-events-none">
                            Invalid Phone Number
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] col-span-2 min-w-0'>
                <span className='whitespace-nowrap px-1 block mb-[2px]'>Date of Last Doctor Visit:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{displayedDateFormats.spouseLastDoctorVisitDate}</span> :
                      <input
                        type='date'
                        name='doctorDateOfLastVisit'
                        style={styledInput}
                        value={spouseData.doctorDateOfLastVisit}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] col-span-2 min-w-0'>
                <span className='whitespace-nowrap px-1 block mb-[2px]'>Reason for Doctor Visit:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.doctorResonForVisit}</span> :
                      <input
                        type='text'
                        name='doctorResonForVisit'
                        style={styledInput}
                        value={spouseData.doctorResonForVisit}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 25th row */}

            <div className='grid grid-cols-7'>
              <div className='border-r border-[#305496] py-[2px] col-span-3 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Doctor's Address:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.doctorAddress}</span> :
                      <input
                        type='text'
                        name='doctorAddress'
                        style={styledInput}
                        value={spouseData.doctorAddress}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Suite #:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.doctorSuiteNumber}</span> :
                      <input
                        type='text'
                        name='doctorSuiteNumber'
                        style={styledInput}
                        value={spouseData.doctorSuiteNumber}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>City:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.doctorCity}</span> :
                      <input
                        type='text'
                        name='doctorCity'
                        style={styledInput}
                        value={spouseData.doctorCity}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>State:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.doctorState}</span> :
                      <input
                        type='text'
                        name='doctorState'
                        style={styledInput}
                        value={spouseData.doctorState}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Zip:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.doctorZip}</span> :
                      <div className='relative group w-full'>
                        <input
                          type='text'
                          inputMode='numeric'
                          maxLength={5}
                          placeholder='5-digit ZIP'
                          name='doctorZip'
                          data-invalid={!optionalFieldsValidity.spouseDoctorZip}
                          style={optionalFieldsValidity.spouseDoctorZip ? styledInput : styledNotValid}
                          value={spouseData.doctorZip}
                          onChange={handleSpouseChange}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.spouseDoctorZip && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] right-0 whitespace-nowrap pointer-events-none">
                            Invalid 5-Digit ZIP
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
            </div>




            {/* 26th row */}

            <div className='grid'>
              <div className='border-y border-r border-[#305496] py-[2px] bg-indigo-100 font-bold'>EMPLOYER</div>
            </div>




            {/* 27th row */}

            <div className='grid grid-cols-5 border-b border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Employer Name:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.employerName}</span> :
                      <input
                        type='text'
                        name='employerName'
                        style={styledInput}
                        value={spouseData.employerName}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Occupation / Job Title:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.employerJob}</span> :
                      <input
                        type='text'
                        name='employerJob'
                        style={styledInput}
                        value={spouseData.employerJob}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Annual Income: $</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.employerAnnualIncome}</span> :
                      <input
                        type='number'
                        name='employerAnnualIncome'
                        style={styledInput}
                        value={spouseData.employerAnnualIncome}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
            </div>




            {/* 28th row */}

            <div className='grid grid-cols-5 border-b-[3px] border-[#305496]'>
              <div className='border-r border-[#305496] py-[2px] col-span-2 flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Address:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.employerAddress}</span> :
                      <input
                        type='text'
                        name='employerAddress'
                        style={styledInput}
                        value={spouseData.employerAddress}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>City:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.employerCity}</span> :
                      <input
                        type='text'
                        name='employerCity'
                        style={styledInput}
                        value={spouseData.employerCity}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='border-r border-[#305496] py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>State:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.employerState}</span> :
                      <input
                        type='text'
                        name='employerState'
                        style={styledInput}
                        value={spouseData.employerState}
                        onChange={handleSpouseChange}
                        className='w-full'
                      />
                  }
                </div>
              </div>
              <div className='py-[2px] flex items-center min-w-0'>
                <span className='whitespace-nowrap'>Zip:</span>
                <div className='w-full px-1 min-w-0'>
                  {
                    sending ?
                      <span className='break-words leading-tight'>{spouseData.employerZip}</span> :
                      <div className='relative group w-full'>
                        <input
                          type='text'
                          inputMode='numeric'
                          maxLength={5}
                          placeholder='5-digit ZIP'
                          name='employerZip'
                          data-invalid={!optionalFieldsValidity.spouseEmployerZip}
                          style={optionalFieldsValidity.spouseEmployerZip ? styledInput : styledNotValid}
                          value={spouseData.employerZip}
                          onChange={handleSpouseChange}
                          className='w-full'
                        />
                        {!optionalFieldsValidity.spouseEmployerZip && (
                          <div className="absolute bg-red-600 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded shadow z-20 -bottom-[20px] right-0 whitespace-nowrap pointer-events-none">
                            Invalid 5-Digit ZIP
                          </div>
                        )}
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>




          {/* DEPENDENTS */}
          <div className='grid grid-cols-[25px_1fr] mt-[-3px] border-t border-[#305496]'>

            <div className='border-l border-t-[3px] border-r-[4px] row-span-13 flex items-center justify-center bg-indigo-300 border-[#305496] ml-[-1px]'>
              <div className='-rotate-90 h-[25px] text-nowrap flex items-center ml-[-3px] font-bold text-[14px]'>DEPENDENTS (if any)</div>
            </div>




            {/* 17th row */}
            <table className='w-full border-r border-b border-[#305496]'>
              <thead>
                <tr>
                  <th className='font-bold pt-1 border-r border-b border-[#305496]'>Last Name, First Name, Middle Name</th>
                  <th className='font-bold pt-1 border-r border-b border-[#305496]'>Gender</th>
                  <th className='font-bold pt-1 border-r border-b border-[#305496]'>Social Security #</th>
                  <th className='font-bold pt-1 border-r border-b border-[#305496]'>Birth Date</th>
                  <th className='font-bold pt-1 border-r border-b border-[#305496]'>Age</th>
                  <th className='font-bold pt-1 border-r border-b border-[#305496]'>Height(ft/in)</th>
                  <th className='font-bold pt-1 border-r border-b border-[#305496]'>Weight</th>
                  <th className='font-bold pt-1 border-b border-[#305496]'>Full Time Student</th>
                </tr>
              </thead>
              <tbody>

                {dependents.map((_, index) => (
                  <tr className='border-b border-[#305496]' key={index}>
                    <td className='border-r border-[#305496] relative'>
                      <div className='w-4 h-full top-0 absolute border-r flex items-center justify-center border-[#305496]'>{index + 1}</div>
                      <div className='ml-5'>
                        <div className='grid grid-cols-3 relative'>
                          {
                            sending ?
                              <>
                                <div className='break-words leading-tight text-center'>{`${dependents[index].lastName === "" ? "" : dependents[index].lastName + ","}`}</div>
                                <div className='break-words leading-tight text-center'>{`${dependents[index].firstName}`}</div>
                                <div className='break-words leading-tight text-center'>{`${dependents[index].middleName}`}</div>
                              </>
                              :
                              <>
                                <input
                                  type='text'
                                  name='lastName'
                                  style={styledInput}
                                  value={dependents[index].lastName}
                                  onChange={(e) => handleDependentsChange(e, index)}
                                  className=''
                                />
                                <input
                                  type='text'
                                  name='firstName'
                                  style={styledInput}
                                  value={dependents[index].firstName}
                                  onChange={(e) => handleDependentsChange(e, index)}
                                  className='ml-1'
                                />
                                <input
                                  type='text'
                                  name='middleName'
                                  style={styledInput}
                                  value={dependents[index].middleName}
                                  onChange={(e) => handleDependentsChange(e, index)}
                                  className='ml-1'
                                />
                              </>
                          }
                        </div>
                      </div>
                    </td>
                    <td className='border-r border-[#305496] text-center space-y-1 py-[2px]'>
                      <div className='flex items-center text-[9px] h-[10px] mx-[3px]'><input type='radio' className='w-[9px] h-[9px] mr-[3px]' name={`dependent-gender${index}`} readOnly /> Male</div>
                      <div className='flex items-center text-[9px] h-[10px] mx-[3px]'><input type='radio' className='w-[9px] h-[9px] mr-[3px]' name={`dependent-gender${index}`} readOnly /> Female</div>
                    </td>
                    <td className='border-r border-[#305496] py-[2px] text-center'>
                      <div className='w-full px-1'>
                        {
                          sending ?
                            dependents[index].ssn :
                            <input
                              type='number'
                              name='ssn'
                              style={styledInput}
                              value={dependents[index].ssn}
                              onChange={(e) => handleDependentsChange(e, index)}
                              className='w-full'
                            />
                        }
                      </div>
                    </td>
                    <td className='border-r border-[#305496] py-[2px] text-center'>
                      <div className='w-full px-1'>
                        {
                          sending ?
                            displayedDateFormats.dependents[index].birthDate :
                            <input
                              type='date'
                              name='birthDate'
                              style={styledInput}
                              value={dependents[index].birthDate}
                              onChange={(e) => handleDependentsChange(e, index)}
                              className='w-full'
                            />
                        }
                      </div>
                    </td>
                    <td className='border-r border-[#305496] py-[2px] w-10 text-center'>
                      <div className='w-full px-1'>
                        {
                          sending ?
                            dependents[index].age :
                            <input
                              type='number'
                              name='age'
                              style={styledInput}
                              value={dependents[index].age}
                              onChange={(e) => handleDependentsChange(e, index)}
                              className='w-full'
                            />
                        }
                      </div>
                    </td>
                    <td className='border-r border-[#305496] py-[2px] w-24 text-center'>
                      <div className='flex justify-center w-full px-1'>

                        {
                          sending ?
                            `${dependents[index].heightFeet === "" ? "" : dependents[index].heightFeet + "'"}${dependents[index].heightInch === "" ? '' : dependents[index].heightInch + '"'}` :
                            <div className='relative group w-full'>
                              <div className='flex justify-between w-full'>
                                <div className='flex items-center'>
                                  <select
                                    style={styledInput}
                                    name='heightFeet'
                                    value={dependents[index].heightFeet}
                                    onChange={(e) => handleDependentsChange(e, index)}
                                  >
                                    <option value="" defaultValue></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                  </select>
                                  <div className='ml-[2px]'>ft</div>
                                </div>
                                <div className='flex items-center'>
                                  <select
                                    style={styledInput}
                                    name='heightInch'
                                    value={dependents[index].heightInch}
                                    onChange={(e) => handleDependentsChange(e, index)}
                                  >
                                    <option value="" defaultValue></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                  </select>
                                  <div className='ml-[2px]'>in</div>
                                </div>
                              </div>
                            </div>
                        }

                      </div>
                    </td>
                    <td className='border-r border-[#305496] py-[2px] w-10 text-center'>
                      <div className='w-full px-1'>
                        {
                          sending ?
                            dependents[index].weight :
                            <input
                              type='number'
                              name='weight'
                              style={styledInput}
                              value={dependents[index].weight}
                              onChange={(e) => handleDependentsChange(e, index)}
                              className='w-full'
                            />
                        }
                      </div>
                    </td>
                    <td className='space-y-1 py-[2px]'>
                      <div className='flex items-center text-[9px] h-[10px] ml-3'><input type='radio' className='w-[9px] h-[9px] mr-[3px]' name={`isFullTimeStudent${index}`} readOnly /> Yes</div>
                      <div className='flex items-center text-[9px] h-[10px] ml-3'><input type='radio' className='w-[9px] h-[9px] mr-[3px]' name={`isFullTimeStudent${index}`} readOnly /> No</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>


        {/* Footer */}
        <div className='w-full absolute bottom-7 left-0 flex justify-between text-[9px] mt-4 px-16'>
          <div className='text-error'><span className='text-sm'>*</span> Required Field</div>
          <div>Page 1 of 2</div>
        </div>
      </div>
    </>
  );
};

export default Page1;
